import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, DialogContentText, DialogActions, } from '@mui/material';
import { Spinner, Form } from 'reactstrap';
import { toast } from 'react-toastify';
import { api } from '../../services/api';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Add, DeleteOutline, Warning } from '@mui/icons-material';

const PVSModal = ({ open, onClose, loading }) => {
  const param = useParams();
  const [showForm, setShowForm] = useState(false);
  const [credentials, setCredentials] = useState([]);
  const [selectedCredential, setSelectedCredential] = useState("");
  const [selectedCredentialDetails, setSelectedCredentialDetails] = useState(null);
  const [loadingCredentials, setLoadingCredentials] = useState(false);

  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const [formData, setFormData] = useState({
    nombre: '',
    client_id: '',
    client_secret: ''
  });

  useEffect(() => {
    if (open) {
      loadCredentials();
    }
  }, [open]);

  useEffect(() => {
    if (selectedCredential) {
      loadCredentialDetails();
    } else {
      setSelectedCredentialDetails(null);
    }
  }, [selectedCredential]);

  const loadCredentials = async () => {
    setLoadingCredentials(true);
    try {
      const response = await api.pvs.getCredential();
      if (response.status === "success") {
        setCredentials(response.data);
      }
    } catch (error) {
      toast.error("Error al cargar las credenciales");
    } finally {
      setLoadingCredentials(false);
    }
  };

  const loadCredentialDetails = async () => {
    if (!selectedCredential) return;

    setLoadingDetail(true);
    try {
      const response = await api.pvs.getCredentialById(selectedCredential);
      if (response.status === "success") {
        setSelectedCredentialDetails(response.data);
      }
    } catch (error) {
      toast.error("Error al cargar los detalles de la credencial");
      setSelectedCredentialDetails(null);
    } finally {
      setLoadingDetail(false);
    }
  };

  const openConfirmDialog = () => {
    setConfirmDelete(true);
  }

  const closeConfirmDialog = () => {
    setConfirmDelete(false);
  }

  const handleDeleteCredential = async () => {
    setLoadingDelete(true);
    try {
      const response = await api.pvs.deleteCredential(selectedCredential);
      if (response.status === "success") {
        toast.success("Credencial eliminada exitosamente");
        setSelectedCredential('');
        setSelectedCredentialDetails(null);
        loadCredentials();
      } else {
        toast.error("Error al eliminar la credencial");
      }
    } catch (error) {
      toast.error("Error al eliminar la credencial");
    } finally {
      setLoadingDelete(false);
      closeConfirmDialog();
    }
  };

  const renderCredentialDetails = () => {
    if (loadingDetail) {
      return (
        <div className="text-center my-3">
          <Spinner color="primary" />
        </div>
      );
    }

    if (!selectedCredentialDetails) return null;

    return (
      <div className="my-3">
        <div style={{ backgroundColor: "#FAFAFB", borderRadius: "8px", padding: "16px", border: "1px solid #E6E6FF" }}>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <p className='mb-0' style={{ color: "#0B0060", fontWeight: "500", fontSize: "18px" }}>Información de la credencial</p>
            <button
              type="button"
              onClick={openConfirmDialog}
              disabled={loadingDelete}
              style={{ fontSize: "14px !important", padding: "0", fontFamily: "Bricolage Grotesque", color: "red" }}
            >
              {loadingDelete ? (
                <Spinner size="sm" />
              ) : (
                <>
                  <DeleteOutline fontSize="small" style={{ marginRight: "4px" }} />
                  <span>Eliminar</span>
                </>
              )}
            </button>
          </div>
          <div className='d-flex flex-column gap-2 '>
            <div>
              <p className='mb-0' style={{ fontWeight: "600" }}>Nombre: </p>
              <span>{selectedCredentialDetails?.nombre}</span>
            </div>
            <div>
              <p className='mb-0' style={{ fontWeight: "600" }}>Client ID: </p>
              <span>{selectedCredentialDetails?.client_id ?
                `****${selectedCredentialDetails.client_id.substring(selectedCredentialDetails.client_id.length - 5)}`
                : 'N/A'}</span>
            </div>
            <div>
              <p className='mb-0' style={{ fontWeight: "600" }}>Client Secret: </p>
              <span>{selectedCredentialDetails?.client_secret ?
                `****${selectedCredentialDetails.client_secret.substring(selectedCredentialDetails.client_secret.length - 5)}`
                : 'N/A'}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      let response;

      if (showForm) {
        response = await api.pvs.createCredential(formData);
        if (response.status === "success") {
          const assignResponse = await api.pvs.assignCredential({
            idevento: parseInt(param?.id),
            idcredencial: response.data.id
          });

          if (assignResponse.status === "success") {
            toast.success("Credencial creada y asignada exitosamente");
            onClose();
            window.location.reload();
          }
        }
      } else {

        response = await api.pvs.assignCredential({
          idevento: parseInt(param?.id),
          idcredencial: parseInt(selectedCredential)
        });

        if (response.status === "success") {
          toast.success("Credencial asignada exitosamente");
          onClose();
          window.location.reload();
        }
      }
    } catch (error) {
      toast.error(error.message || "Error al procesar la solicitud");
    }
  };

  const handleClose = () => {
    setShowForm(false);
    setSelectedCredential('');
    setFormData({
      nombre: '',
      client_id: '',
      client_secret: ''
    });
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ padding: "16px 24px 10px !important", color: "#5656FF", fontSize: "20px", fontWeight: "600" }}>
          {showForm ? "Nueva credencial PVS" : "Seleccionar credencial PVS"}
        </DialogTitle>
        <DialogContent>
          {!showForm ? (
            <div className="mt-3">
              {loadingCredentials ? (
                <div className="text-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <select
                    className="form-select mb-2"
                    value={selectedCredential}
                    onChange={(e) => setSelectedCredential(e.target.value)}
                  >
                    <option value="">Seleccionar credencial...</option>
                    {credentials.map(cred => (
                      <option key={cred.id} value={cred.id}>
                        {cred.nombre}
                      </option>
                    ))}
                  </select>

                  {selectedCredential && renderCredentialDetails()}

                  <div className={`d-flex ${window.innerWidth <= 576 ? 'flex-column' : 'justify-content-between'} mt-4`}
                    style={{ gap: window.innerWidth <= 576 ? '10px' : '0' }}>
                    <button
                      type='button'
                      style={{
                        border: "1px solid #5656FF",
                        color: "#5656FF",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: window.innerWidth <= 576 ? "13px" : "14px",
                        width: window.innerWidth <= 576 ? "100%" : "auto"
                      }}
                      onClick={() => setShowForm(true)}
                    >
                      <Add fontSize="small" style={{ marginRight: "4px" }} />
                      Crear nueva credencial
                    </button>
                    <button
                      style={{
                        backgroundColor: "#5656FF",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: window.innerWidth <= 576 ? "13px" : "14px",
                        width: window.innerWidth <= 576 ? "100%" : "auto"
                      }}
                      disabled={!selectedCredential || loading}
                      onClick={handleSave}
                    >
                      {loading ? <Spinner size="sm" /> : 'Asignar credencial'}
                    </button>
                  </div>
                </>
              )}
            </div>
          ) : (
            <Form onSubmit={handleSave} className="mt-3">
              <div className="mb-3">
                <label className="form-label">Nombre de la credencial</label>
                <input
                  type="text"
                  className="form-control"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Client ID</label>
                <input
                  type="text"
                  className="form-control"
                  name="client_id"
                  value={formData.client_id}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Client Secret</label>
                <input
                  type="password"
                  className="form-control"
                  name="client_secret"
                  value={formData.client_secret}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="d-flex justify-content-between mt-4">
                <Button
                  variant="outlined"
                  sx={{ borderColor: "#5656FF", color: "#5656FF" }}
                  onClick={() => setShowForm(false)}
                >
                  Volver
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ backgroundColor: "#5656FF", color: "white" }}
                  disabled={loading}
                >
                  {loading ? <Spinner size="sm" /> : 'Guardar credencial'}
                </Button>
              </div>
            </Form>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={confirmDelete}
        onClose={closeConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title" sx={{ display: "flex", alignItems: "center" }}>
          <Warning color="warning" sx={{ mr: 1 }} />
          Confirmar eliminación
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Estás seguro de que deseas eliminar esta credencial? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={closeConfirmDialog}
            type='button'
            style={{
              backgroundColor: "transparent",
              color: "#5656FF",
              border: "1px solid #5656FF",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleDeleteCredential}
            autoFocus
            disabled={loadingDelete}
            type='button'
            style={{
              backgroundColor: "red",
              color: "white",
              border: "none",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            {loadingDelete ? (
              <Spinner size="sm" />
            ) : (
              <>
                <DeleteOutline fontSize="small" style={{ marginRight: "4px" }} />
                Eliminar
              </>
            )}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PVSModal;